import { store } from '../../../src/store';
import {createApp} from 'vue';

if(document.querySelector('.c-hero-formation')){
	var app_formation_hero = createApp({
		data(){
			return{
				completedActivity: false,
				notificationOpen:true,

				productType: "",
				productList: []
			}
		},
		mounted(){
			console.log('loaded');
		},
		methods:{
			goToCheckout: function(event){
				let url = event.currentTarget.dataset['href'];
				this.productType = event.currentTarget.dataset['prodType'];
				let prod = {
					id: event.currentTarget.dataset['prodId'],
					title: event.currentTarget.dataset['title'],
					img: event.currentTarget.dataset['img'],
					tag: event.currentTarget.dataset['tag'],
					url: event.currentTarget.dataset['url'],
					fullPrice: event.currentTarget.dataset['fullPrice'],
					interPrice: event.currentTarget.dataset['interPrice'],
					collegiatPrice: event.currentTarget.dataset['colPrice'],
					startDate: event.currentTarget.dataset['start'],
					endDate: event.currentTarget.dataset['end'],
					location: event.currentTarget.dataset['location']
				}
				this.productList.push(prod);
				sessionStorage.setItem('checkoutProductsType', this.productType);
				sessionStorage.setItem('checkoutProducts', JSON.stringify(this.productList));
				window.location.href = url;
			}
		}
	}).mount(document.querySelector('.c-hero-formation'));
}